import React from 'react';
import { AppBar, Avatar, Box, IconButton, Toolbar, Tooltip, Typography, useTheme } from '@mui/material';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { useDispatch, useSelector } from 'react-redux';
import { logout, selectUser } from '../api/auth/authSlice';
import { useNavigate } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import lightTheme from '../theme';
import appConfig from '../config/appConfig';

function Header({ toggleSidebar }) {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(selectUser);

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login', { replace: true });
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: theme.palette.common.white,
        boxShadow: theme.shadows[3],
      }}
    >
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={toggleSidebar}
          edge="start"
          sx={[
            {
              display: { xs: 'block', sm: 'block', md: 'none' },
              mr: 2,
              color: 'black',
            },
          ]}
        >
          <MenuIcon />
        </IconButton>
        <img src={appConfig.brandLogoPath} height="35" alt="Logo" style={{ marginRight: theme.spacing(2) }} />
        <Typography
          variant="h5"
          noWrap
          component="div"
          color="black"
          sx={{ fontWeight: theme.typography.fontWeightBold }}
        ></Typography>
        <Box sx={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
          {user?.role === 'partner' && (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                backgroundColor: theme.palette.action.hover,
                padding: theme.spacing(0.5, 1),
                borderRadius: theme.shape.borderRadius,
                marginRight: theme.spacing(2),
              }}
            >
              <Tooltip
                title={user.name}
                arrow
                slotProps={{
                  tooltip: {
                    sx: {
                      fontSize: '1rem',
                      padding: theme.spacing(1),
                      color: theme.palette.common.white,
                    },
                  },
                }}
              >
                <Avatar
                  sx={{
                    bgcolor: lightTheme.palette.secondary.main,
                    width: 35,
                    height: 35,
                    fontSize: 20,
                  }}
                >
                  {user.name.charAt(0).toUpperCase()}
                </Avatar>
              </Tooltip>
            </Box>
          )}
          <IconButton
            onClick={handleLogout}
            sx={{
              borderRadius: 0,
              '&:hover': {
                backgroundColor: theme.palette.action.hover,
              },
            }}
          >
            <ExitToAppIcon sx={{ marginRight: 1 }} />
            Logout
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
